import React, { useEffect, useState } from 'react'
import SubmitButton from '../../components/controls/SubmitButton/SubmitButton'

import nexiLogo from "../.././assets/logo-nexi-group.png";
import styles from './EditOperationalArea.module.css';
import { OperationalScopeServicesApi } from '../../service';
import Loading from '../../components/Loading/Loading';
import GenericModal from '../../UI/GenericModal';
import { useHistory } from 'react-router-dom';
import { isSuperuserValue } from '../../access/access';

let urlSearchParams = new URLSearchParams(window.location.search);
let params = Object.fromEntries(urlSearchParams.entries());
let queryStringOpAreaId = params["opAreaId"];

const EditOperationalArea = () => {
  const [controlFunctions, setControlFunctions] = useState([]);
  const [opScopeName, setOpScopeName] = useState("");
  const [opScopeTooltip, setOpScopeTooltip] = useState("");
  const [isActiveScope, setIsActiveScope] = useState(true);
  const [opAreaId, setOpAreaId] = useState();
  const [isLoading, setIsLoading] = useState();

  const [error, setError] = useState();

  const [modalShow, setModalShow] = useState(false);
  const [modalAction, setModalAction] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalMessage, setModalMessage] = useState();
  const [modalType, setModalType] = useState();

  const history = useHistory();

  useEffect(() => {
    if (!isSuperuserValue()) {
      history.push("/home");
    }
    let mounted = true;
    setIsLoading(true);

    urlSearchParams = new URLSearchParams(window.location.search);
    params = Object.fromEntries(urlSearchParams.entries());
    queryStringOpAreaId = params["opAreaId"];
    setOpAreaId(queryStringOpAreaId);

    const operationalScopeServicesApi = new OperationalScopeServicesApi();
    operationalScopeServicesApi.getOperationalScopeById(queryStringOpAreaId, (error, data) => {
      console.log("opScope details: ", data);
      if (mounted) {
        if (!error) {
          console.log("opScope data: ", data)
          setOpScopeName(data.name);
          setIsActiveScope(data.active);
          setOpScopeTooltip(data.tooltip);
          setControlFunctions(data.controlFunctions.filter(cf => cf.active === true).map((item) => {
            return {
              id: item.id,
              name: item.name,
              value: item.active
            }
          })
          .sort( (a,b) => a.id > b.id ? 1 : -1));
          setIsLoading(false);
        } else {
          setError(() => {
            throw new Error ("");
            // throw new Error ("Error " + (error.response ? error.response.statusCode : "") + " " + error.message);
          })
        }
      }
    })
    return (() => {
      mounted = false;
    })
  },[]);

  const opScopeNameHandler = (value) => {
    setOpScopeName(value);
  }

  const opScopeTooltipHandler = (value) => {
    setOpScopeTooltip(value);
  }

  const updateControlFunctionValue = (id, value) => {
    const newControlFunctionValues = [...controlFunctions];
    for (const el of newControlFunctionValues) {
      if (el.id === id) {
        el.value = value;
        break;
      }
    }
    setControlFunctions(newControlFunctionValues);
  }

  const updateActiveScopeValue = (value) => {
    console.log("Active value: ", value);
    setIsActiveScope(value);
  }

  const submitFormHandler = () => {
    console.log("Submit function")
    if (validValues) {
      setIsLoading(true);
      const requestBody = {
        id: opAreaId,
        name: opScopeName,
        tooltip: opScopeTooltip,
        active: isActiveScope,
        controlFunctionIds: controlFunctions.filter(el => el.value === true).map(el => el.id)
      }
      
      const operationalScopeServicesApi = new OperationalScopeServicesApi();
      operationalScopeServicesApi.updateOperationalScopeById(requestBody, opAreaId, (error, data) => {
        if (!error) {
          setIsLoading(false);
          modalDataHandler("", `The operational area "${opScopeName}" was updated`, 'notification', () => history.push("/operational-area-monitor"))  
        } else {
          setIsLoading(false);
          modalDataHandler(`Error ${(error.response ? error.response.statusCode : "")}`, `An error ocurred. The operational area could not be updated!`, 'error', modalCloseHandler)  
        }
      })
    } else {
      modalDataHandler("", `The operational area must have a name and at least one control function must be selected`, 'notification', modalCloseHandler)
    }
  }

  const validValues = () => {
    let activeCFunctions = controlFunctions.filter(el => el.value === true);
    if (activeCFunctions.length === 0 || opScopeName.length === 0) {
      return false;
    } else {
      return true;
    }
  }

  const modalDataHandler = (title, message, modType, action) => {
    setModalAction(() => action );
    setModalTitle(title);
    setModalMessage(message);
    setModalShow(true);
    setModalType(modType);
  }

  const modalCloseHandler = () => {
    setModalShow(false)
  }

  const requestBody = {
    name: opScopeName,
    active: isActiveScope,
    controlFunctionIds: controlFunctions.filter(el => el.value === true).map(el => el.id)
  }

  // console.log("requestBody: ", requestBody);

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      modalDataHandler(
        "Update Operational Area",
        "Update operational area?",
        'confirmation',
        submitFormHandler
      )}}>
      <GenericModal
        show={modalShow}
        handleClose={modalCloseHandler}
        action={modalAction}
        title={modalTitle}
        message={modalMessage}
        modalType={modalType}
      />
      <div className="d-flex justify-content-between mt-2">
        <div className="d-flex flex-column">
          <label className="fw-bold mb-1 ms-1">
            Operational Scope Name
          </label>
          <input
            className={styles.textInput}
            value={opScopeName ? opScopeName : ""}
            type="text"
            onChange={(e) => {
              opScopeNameHandler(e.target.value);
            }}
            placeholder="Type the new operational scope"
            />
        </div>
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="active" className="mb-1 fw-bold">
            Active
          </label>
          <input
            type="checkbox"
            checked={isActiveScope ? 'checked' : ''}
            id="active"
            className={styles.activeCheckbox}
            name="activeValue"
            onChange={(e) => {
              updateActiveScopeValue(e.target.checked)
            }}
          />
        </div>
        <div>
          <img src={nexiLogo} className={`${styles.logo}`} alt="nexi-group" />
        </div>
      </div>
      <div className="d-flex flex-column mt-2">
        <label className="fw-bold mb-1 ms-1">
          Description
        </label>
        <input
          className={`${styles.textInput} ${styles.tooltip}`}
          value={opScopeTooltip ? opScopeTooltip : ""}
          type="text"
          onChange={(e) => {
            opScopeTooltipHandler(e.target.value);
          }}
          placeholder="Type a new description"
          />
      </div>
      <p className="fw-bold mb-1 mt-4 ms-1">Scope</p>
      <div className="hr position-relative">
      </div>
      {isLoading && <Loading height={"82px"} />}
      {!isLoading && (
        <div
          style={{ maxWidth: "580px" }}
          className="d-flex justify-content-between mt-2 me-2"
        >
          <label className="fst-italic ms-1">Control functions:</label>
          {controlFunctions.map((item) => (
            <div key={item.id}>
              <input
                type="checkbox"
                checked={item.value ? 'checked' : ''}
                id={item.id}
                onChange={(e) => {
                  updateControlFunctionValue(item.id, e.target.checked);
                }}
                name="control-functions"
              />
              <label htmlFor={item.id} className="ms-2 fw-bold">
                {item.name}
              </label>
            </div>
          ))}
        </div>
      )}
      {!isLoading && <SubmitButton
        type="submit"
        disabled={!validValues()}
        class={`${styles.submitButton} mt-3 mb-1 me-3 float-end`}
      >Update</SubmitButton>}
    </form>
  );
}

export default EditOperationalArea;
